
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const RecordsPage = lazy(() => import('../pages/records/page'));
const LicensingPublishingPage = lazy(() => import('../pages/licensing-publishing/page'));
const ManagementPage = lazy(() => import('../pages/management/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/records',
    element: <RecordsPage />,
  },
  {
    path: '/licensing-publishing',
    element: <LicensingPublishingPage />,
  },
  {
    path: '/management',
    element: <ManagementPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
